/**
 * Module to manage pricing for an item
 *
 * Copyright 2014 Lightspeed Retail. All rights reserved.
 * Created by kurtbergeron on 2014-08-21.
 */
/**
 * The global prices object.  Encapsulates the behaviour of advanced pricing information for an item.
 */
window.merchantos.prices = {
  RecordType: {
    ITEM: 'Item',
    MATRIX: 'ItemMatrix',
  },

  /**
   * Determines if there is a prices container in which to render the price information.
   *
   * @param $view {jQuery.Object}     The current view (#view).
   * @returns {boolean}               True if a container has been located or false otherwise.
   */
  hasPrices($view) {
    return this.getPricesContainer($view).length > 0;
  },

  /**
   * Retrieves the prices container from the DOM.
   *
   * @param $view                 The current view (#view).
   * @returns {jQuery.Object}     The container that will be used to render pricing information.
   */
  getPricesContainer($view) {
    return $view.find('#item-pricing,#item-group-price-defaults');
  },

  getRecordType($prices) {
    const id = $prices.prop('id');
    if ($prices.length === 1) {
      if (id === 'item-pricing') {
        return this.RecordType.ITEM;
      }
      if (id === 'item-group-price-defaults') {
        return this.RecordType.MATRIX;
      }
      throw new Error('Unknown pricing record type');
    } else {
      throw new Error('Only one price listing may be present at a time');
    }
  },

  /**
   * Saves the advanced pricing information to the server
   *
   * @param $view                 The current view (#view).
   * @returns {jQuery.Promise}
   */
  save($view) {
    let deferred = $.Deferred();

    if (this.hasPrices($view)) {
      const $prices = this.getPricesContainer($view);
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const id = $view[0].view.record_id;

      if ($prices.length) {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number | undefined' is ... Remove this comment to see the full error message
        const data = this.constructUpdateData(id, $prices);

        // @ts-expect-error ts-migrate(2740) FIXME: Type 'jqXHR<any>' is missing the following propert... Remove this comment to see the full error message
        deferred = $.ajax({
          url: `/API/Account/${window.merchantos.account.id}/${this.getRecordType(
            $prices
          )}/${id}.json`,
          type: 'PUT',
          dataType: 'json',
          data: JSON.stringify(data),
        });
      }
    } else {
      deferred.resolve();
    }

    return deferred.promise();
  },

  /**
   * The event handler triggered after a price has been changed.   Updates the markup and margin appropriately.
   *
   * @param event {Event}      The triggering event
   * @param cost {Number}      The item cost
   */
  onPriceChange(event, cost) {
    const $price = $(event);
    const $markup = $price.parent().siblings('td.markup');
    const $margin = $price.parent().siblings('td.margin');
    const amount = $price.val();

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
    $markup.text(this.formatPercentage(this.calcMarkup.call(this, amount, cost)));
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
    $margin.text(this.formatPercentage(this.calcMargin.call(this, amount, cost)));
  },

  /**
   * Auto-fills price input fields to match the default field
   *
   * @param changedEl     The input holding the default price
   */
  onDefaultPriceChange(changedEl) {
    const defaultPrice = changedEl.value;
    const $linkedPrices = $('.default-linked').find('input');

    $linkedPrices.val(defaultPrice);
  },

  /**
   * Unlinks a price field from the default price, meaning it no longer
   * changes when the default input changes
   *
   * @param changedEl     The input field that changed
   */
  unlinkFromDefault(changedEl) {
    $(changedEl).parent().removeClass('default-linked');
  },

  /**
   * Retrieves the calculated markup for the specified price.
   *
   * @param amount {Number}   The item price
   * @param cost {Number}     The item cost
   * @returns {String}        The calculated markup expressed as a percentage.  If the markup cannot be determined '-' will be
   *                          returned.
   */
  getMarkup(amount, cost) {
    return this.formatPercentage(this.calcMarkup.call(this, amount, cost));
  },

  /**
   * Retrieves the calculated margin for the specified price.
   *
   * @param amount {Number}   The item price
   * @param cost {Number}     The item cost
   * @returns {String}        The calculated margin expressed as a percentage.  If the margin cannot be determined '-' will be
   *                          returned.
   */
  getMargin(amount, cost) {
    return this.formatPercentage(this.calcMargin.call(this, amount, cost));
  },

  /**
   * Formats a fractional rate as a percentage.
   *
   * @param rate {Number}     The rate.
   * @returns {string}        The rate expressed as a percentage with a fixed precision of 1.
   */
  formatPercentage(rate) {
    const formattedPercentage = parseFloat(String(rate));
    if (_.isNaN(formattedPercentage) || !_.isFinite(formattedPercentage)) {
      return '';
    }
    return `${(formattedPercentage * 100).toFixed(1)}%`;
  },

  /**
   * Calculates the markup for the amount specified.
   *
   * @param amount {Number}   The item price
   * @param cost {Number}     The item cost
   * @returns {number}        The markup rate.
   */
  calcMarkup(amount, cost) {
    let calcCost;
    if (cost) {
      calcCost = parseFloat(String(cost));
    }

    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    return amount / calcCost - 1;
  },

  /**
   * Calculates the margin for the amount specified.
   *
   * @param amount {Number}   The item price
   * @param cost {Number}     The item cost
   * @returns {number}        The margin rate.
   */
  calcMargin(amount, cost) {
    let calcCost;
    if (cost) {
      calcCost = parseFloat(String(cost));
    }

    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    return 1 - calcCost / amount;
  },

  /**
   * Determines if the taxable checkbox is rendered in the $prices DOM
   *
   * @param $prices {jQuery.Object}   The price container
   * @returns {Boolean}               True if the taxable checkbox is available
   */
  isTaxableAvailable($prices) {
    if ($prices.find('input[name=tax]').length > 0) {
      return true;
    }
    return false;
  },

  /**
   * Determines if the taxable checkbox is checked
   *
   * @param $prices {jQuery.Object}   The price container
   * @returns {Boolean}               True if the taxable checkbox is checked
   */
  isTaxableChecked($prices) {
    return $prices.find('input[name=tax]').prop('checked');
  },

  /**
   * Determines if the Discounts Allowed checkbox is rendered in the $prices DOM
   *
   * @param $prices {jQuery.Object}   The price container
   * @returns {Boolean}               True if the discountable checkbox is available
   */
  isDiscountableAvailable($prices) {
    if ($prices.find('input[name=discountable]').length > 0) {
      return true;
    }
    return false;
  },

  /**
   * Determines if the Discounts Allowed checkbox is checked
   *
   * @param $prices {jQuery.Object}   The price container
   * @returns {Boolean}               True if the discountable checkbox is checked
   */
  isDiscountableChecked($prices) {
    return $prices.find('input[name=discountable]').prop('checked');
  },

  /**
   * Determines if the Tax Class select is rendered in the $prices DOM
   *
   * @param $prices {jQuery.Object}   The price container
   * @returns {Boolean}               True if the tax class select is available
   */
  isTaxClassAvailable($prices) {
    if ($prices.find('select[name=class_id]').length > 0) {
      return true;
    }
    return false;
  },

  /**
   * Retrieves the currently selected tax class
   *
   * @param $prices {jQuery.Object}   The price container
   * @returns {Number}                The id of the tax class that is currently selected
   */
  getSelectedTaxClass($prices) {
    const selectedTaxClass = parseInt($prices.find('select[name=class_id]').val() as string, 10);
    if (!_.isNaN(selectedTaxClass)) {
      return selectedTaxClass;
    }
    return null;
  },

  /**
   * Retrieves all the price data for every price level listed for the item.
   *
   * @param $prices {jQuery.Object}   The price container
   * @returns {Array}                 An array of all price data of the form:
   *                                  {
   *                                      amount => the currently configured price
   *                                      useType => the name of the price level
   *                                  }
   */
  getPrices($prices) {
    const $itemPrices = $prices.find('tr').slice(1); // the first matched element is the table header so ignore it
    const prices: TSFixMe = [];

    $itemPrices.each((_index, elem) => {
      const $price = $(elem);
      if (this.isAmountChanged($price)) {
        prices.push(this.getPriceData($price));
      }
    });

    return prices;
  },

  /**
   * Retrieves the price data for a specified price level
   *
   * @param $price {jQuery.Object}    The DOM element for the price level
   * @returns {Object}                An object of the form:
   *                                  {
   *                                      amount => the currently configured price
   *                                      useType => the name of the price level
   *                                  }
   */
  getPriceData($price) {
    const priceData = {
      amount: this.getAmount($price),
      useType: this.getUseType($price),
    };

    return priceData;
  },

  /**
   * Determines if the current amount differs from its initial value
   *
   * @param $price {jQuery.Object}    The DOM element for the price level
   * @returns {boolean}               Returns true current amount differs from the initial value
   */
  isAmountChanged($price) {
    const $amount = $price.find('input.pricelevel');
    const amount = parseFloat($amount.val() as string);
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
    const initialAmount = parseFloat($amount.attr('initial-value'));

    return amount !== initialAmount;
  },

  /**
   * Retrieves the currently configured price for a price level for the item
   *
   * @param $price {jQuery.Object}    The DOM element for the price level
   * @returns {Number}                The currently configured price
   */
  getAmount($price) {
    return parseFloat($price.find('input.pricelevel').val() as string);
  },

  /**
   * Retrieves the name of the price level
   *
   * @param $price {jQuery.Object}    The DOM element for the price level
   * @returns {String}                The name of the price level
   */
  getUseType($price) {
    const $th = $price.find('th');
    // Use the data-use-type attribute if it exists, otherwise use the text
    return $th.attr('data-use-type') || $th.text();
  },

  /**
   * Constructs an object in a form suitable for transmission via an API item PUT request.  It includes all data necessary to save
   * price configuration changes for the item.
   *
   * @param id {Number}               The ID of the item or Matrix
   * @param $price {jQuery.Object}    The DOM element for the price level
   * @returns {Object}                An object that corresponds to the data of an API/Account/{id}/PriceLevels/{id} endpoint.
   */
  constructUpdateData(id, $prices) {
    const idName = this.getRecordType($prices) === this.RecordType.ITEM ? 'itemID' : 'itemMatrixID';
    const updateData: Partial<UpdateData> = {
      Prices: {
        ItemPrice: this.getPrices($prices),
      },
    };

    if (this.isTaxableAvailable($prices)) {
      updateData.tax = this.isTaxableChecked($prices);
    }
    if (this.isDiscountableAvailable($prices)) {
      updateData.discountable = this.isDiscountableChecked($prices);
    }
    if (this.isTaxClassAvailable($prices)) {
      updateData.taxClassID = this.getSelectedTaxClass($prices);
    }

    // @ts-expect-error ts-migrate(7015) FIXME: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
    updateData[idName] = id;

    return updateData;
  },
};
